import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4441_21835)">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M10.268 5.25C11.0378 3.91667 12.9623 3.91667 13.7321 5.25L20.6603 17.25C21.4301 18.5833 20.4678 20.25 18.9282 20.25H5.07183C3.53223 20.25 2.56998 18.5833 3.33978 17.25L10.268 5.25ZM11 9.25C11 8.69771 11.4477 8.25 12 8.25C12.5523 8.25 13 8.69771 13 9.25V14.25C13 14.8023 12.5523 15.25 12 15.25C11.4477 15.25 11 14.8023 11 14.25V9.25ZM12 16.25C11.4477 16.25 11 16.6977 11 17.25C11 17.8023 11.4477 18.25 12 18.25C12.5523 18.25 13 17.8023 13 17.25C13 16.6977 12.5523 16.25 12 16.25Z"
              fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_4441_21835">
          <rect width="24" height="24.5" fill="white" transform="translate(0 0.25)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;